module.exports = __webpack_public_path__ + "static/media/hangar logo.c3137eaf.png";